import supabase from '../supabase/supabase';

export async function loadPublicQuote(shareToken) {
  const token=String(shareToken || '').trim();

  if (!token) {
    return null;
  }

  const {data,error}=await supabase.rpc(
    'get_public_quote_by_token',
    {p_share_token: token}
  );

  if (error) {
    throw new Error('The quotation could not be loaded.');
  }

  return data || null;
}

export async function acceptPublicQuote({
  shareToken,
  fullName,
  company,
  email,
  notes,
  selectedExtraIds
}) {
  const selectedIds=(selectedExtraIds || []).map((id)=> String(id));

  const {data,error}=await supabase.rpc(
    'accept_public_quote',
    {
      p_share_token: String(shareToken || '').trim(),
      p_full_name: fullName.trim(),
      p_company: company.trim(),
      p_email: email.trim(),
      p_notes: notes?.trim() || '',
      p_approved: true,
      p_selected_extra_ids: selectedIds
    }
  );

  if (error) {
    throw error;
  }

  return data;
}